import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// 获取列表内容封装在mixins内部  getTableData方法 初始化已封装完成
var path = process.env.VUE_APP_BASE_API;
import { getUserList, setUserAuthority, register, deleteUser as _deleteUser, syncADUsers as _syncADUsers, findSysUser, updateSysUser } from "@/api/user";
import { getAuthorityList } from "@/api/authority";
import infoList from "@/components/mixins/infoList";
import { formatTimeToStr } from '@/utils/data';
import { mapGetters } from "vuex";
export default {
  name: "SysUser",
  mixins: [infoList],
  components: {},
  data: function data() {
    return {
      listApi: getUserList,
      path: path,
      authOptions: [],
      addUserDialog: false,
      dialogFormVisible: false,
      userInfo: {
        username: "",
        password: "",
        nickName: "",
        headerImg: "",
        authorityId: ""
      },
      formData: {
        userName: "",
        nickName: "",
        password: ""
      },
      rules: {
        username: [{
          required: true,
          message: this.$t('user.name_required'),
          trigger: "blur"
        }],
        password: [{
          required: true,
          message: this.$t('user.password_required'),
          trigger: "blur"
        }, {
          min: 6,
          message: this.$t('user.password_min'),
          trigger: "blur"
        }],
        nickName: [{
          required: true,
          message: this.$t('user.nick_name_required'),
          trigger: "blur"
        }],
        authorityId: [{
          required: true,
          message: this.$t('user.role_required'),
          trigger: "blur"
        }]
      }
    };
  },
  computed: _objectSpread({}, mapGetters("user", ["token"])),
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time != "") {
        var date = new Date(time);
        return formatTimeToStr(date, "yyyy-MM-dd hh:mm:ss");
      } else {
        return "";
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? "是" : "否";
      } else {
        return "";
      }
    }
  },
  methods: {
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      console.log(this.searchInfo);
      this.getTableData();
    },
    openHeaderChange: function openHeaderChange() {},
    /** 提交按钮 */
    submitForm: function submitForm() {
      var _this = this;
      if (this.formData.ID !== undefined) {
        updateSysUser(this.formData).then(function (response) {
          if (response.code === 0) {
            _this.$message({
              type: 'success',
              message: _this.$t('common.success')
            });
            _this.dialogFormVisible = false;
            _this.getTableData();
          } else {
            _this.$message({
              type: 'error',
              message: _this.$t('common.error')
            });
          }
        });
      }
    },
    cancel: function cancel() {
      this.dialogFormVisible = false;
      //this.reset()
    },
    setOptions: function setOptions(authData) {
      this.authOptions = [];
      this.setAuthorityOptions(authData, this.authOptions);
    },
    setAuthorityOptions: function setAuthorityOptions(AuthorityData, optionsData) {
      var _this2 = this;
      AuthorityData && AuthorityData.map(function (item) {
        if (item.children && item.children.length) {
          var option = {
            authorityId: item.authorityId,
            authorityName: item.authorityName,
            children: []
          };
          _this2.setAuthorityOptions(item.children, option.children);
          optionsData.push(option);
        } else {
          var _option = {
            authorityId: item.authorityId,
            authorityName: item.authorityName
          };
          optionsData.push(_option);
        }
      });
    },
    deleteUser: function () {
      var _deleteUser2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(row) {
        var _this3 = this;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(row.userName == "admin")) {
                _context2.next = 1;
                break;
              }
              this.$message({
                type: "warning",
                message: "not permited"
              });
              return _context2.abrupt("return");
            case 1:
              this.$confirm(this.$t('common.delete_warning'), "", {
                confirmButtonText: this.$t('common.confirm'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var res;
                return regeneratorRuntime.wrap(function (_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 1;
                      return _deleteUser({
                        id: row.ID
                      });
                    case 1:
                      res = _context.sent;
                      if (!(res.code == 0)) {
                        _context.next = 3;
                        break;
                      }
                      _context.next = 2;
                      return _this3.getTableData();
                    case 2:
                      row.visible = false;
                    case 3:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }))).catch(function () {
                _this3.$message({
                  type: "info",
                  message: _this3.$t('common.cancel')
                });
              });
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function deleteUser(_x) {
        return _deleteUser2.apply(this, arguments);
      }
      return deleteUser;
    }(),
    enterAddUserDialog: function () {
      var _enterAddUserDialog = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this4 = this;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.$refs.userForm.validate(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(valid) {
                  var res;
                  return regeneratorRuntime.wrap(function (_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        if (!valid) {
                          _context3.next = 3;
                          break;
                        }
                        _context3.next = 1;
                        return register(_this4.userInfo);
                      case 1:
                        res = _context3.sent;
                        if (res.code == 0) {
                          _this4.$message({
                            type: "success",
                            message: "创建成功"
                          });
                        }
                        _context3.next = 2;
                        return _this4.getTableData();
                      case 2:
                        _this4.closeAddUserDialog();
                      case 3:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function enterAddUserDialog() {
        return _enterAddUserDialog.apply(this, arguments);
      }
      return enterAddUserDialog;
    }(),
    closeAddUserDialog: function closeAddUserDialog() {
      this.$refs.userForm.resetFields();
      this.addUserDialog = false;
    },
    handleAvatarSuccess: function handleAvatarSuccess(res) {
      this.userInfo.headerImg = res.data.file.url;
    },
    addUser: function addUser() {
      this.addUserDialog = true;
    },
    updateUser: function () {
      var _updateUser = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(row) {
        var res;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 1;
              return findSysUser({
                ID: row.ID
              });
            case 1:
              res = _context5.sent;
              if (res.code == 0) {
                this.formData = res.data.resysUser;
                this.dialogTitle = this.$t('common.edit');
                this.dialogFormVisible = true;
              }
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function updateUser(_x3) {
        return _updateUser.apply(this, arguments);
      }
      return updateUser;
    }(),
    changeAuthority: function () {
      var _changeAuthority = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(row) {
        var res;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 1;
              return setUserAuthority({
                uuid: row.uuid,
                authorityId: row.authority.authorityId
              });
            case 1:
              res = _context6.sent;
              if (res.code == 0) {
                this.$message({
                  type: "success",
                  message: "角色设置成功"
                });
              }
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function changeAuthority(_x4) {
        return _changeAuthority.apply(this, arguments);
      }
      return changeAuthority;
    }(),
    syncADUsers: function () {
      var _syncADUsers2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var res;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 1;
              return _syncADUsers({});
            case 1:
              res = _context7.sent;
              if (res.code == 0) {
                this.$success(this.$t('common.success'));
              } else {
                this.$error(this.$t('common.error'));
              }
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function syncADUsers() {
        return _syncADUsers2.apply(this, arguments);
      }
      return syncADUsers;
    }()
  },
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
      var res;
      return regeneratorRuntime.wrap(function (_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 1;
            return this.getTableData();
          case 1:
            _context8.next = 2;
            return getAuthorityList({
              page: 1,
              pageSize: 999
            });
          case 2:
            res = _context8.sent;
            this.setOptions(res.data.list);
          case 3:
          case "end":
            return _context8.stop();
        }
      }, _callee8, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }()
};